const RelatedProductSkeleton = () => {
  return (
    <div className='flex w-full min-w-[113px] animate-pulse flex-col gap-[6px] rounded-[12px] border border-[#e2e8f0] bg-[#f8fafc] p-[8px]'>
      <div className='h-26 w-23.75 rounded-[8px] border-2 border-[#e2e8f0] bg-gray-200' />

      <div className='h-[31px] rounded bg-gray-200' />

      <div className='flex items-center gap-1 font-extrabold'>
        <div className='h-4 w-10 rounded bg-gray-200' />
      </div>

      <div className='h-[32px] rounded-[10px] bg-gray-200' />
    </div>
  );
};

export default RelatedProductSkeleton;
